import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGooglePodcastsBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePodcastsBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd8b81b8b8583d904ef0887c06dc20ca2f2bcabf5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '470419016884434887bf10d0ee9bcc2fd127cb8e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3efa28c05dfb7b80f2d9dc91844f4bbf5d2aa2ad', d: "M4 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1", fill: "#0066D9" }), h("path", { key: 'b79f8ae58ad39b33a5f513d334b3653077128bc5', d: "M18 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1", fill: "#4285F4" }), h("path", { key: '3f2dd0c516663a9c960134544918de2fc6483117', d: "M7.454 12.727a1 1 0 0 0-1 1v1.091a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1m0-6.546a1 1 0 0 0-1 1v3.568a1 1 0 0 0 2 0V7.182a1 1 0 0 0-1-1", fill: "#EA4335" }), h("path", { key: '07775876d1ad9efbac43c8068c353528f88a7264', d: "M14.545 6.182a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1", fill: "#34A853" }), h("path", { key: '7513f6091060f1462e7d0d1132003fb07c7e9768', d: "M11 3a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1m0 12.91a1 1 0 0 0-1 1V18a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1", fill: "#FAB908" }), h("path", { key: '03be9e1d90eeffe216500fdfaecbbea39c71bf74', d: "M14.545 10.273a1 1 0 0 0-1 1v3.545a1 1 0 1 0 2 0v-3.545a1 1 0 0 0-1-1", fill: "#34A853" }), h("path", { key: '6abcf3798334d22457a2ef2240b386244407456d', d: "M12 8.09a1 1 0 1 0-2 0v5.82a1 1 0 1 0 2 0z", fill: "#FAB908" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-google-podcasts-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-podcasts-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-podcasts-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePodcastsBranded$1);
            }
            break;
    } });
}

const CosmosIconGooglePodcastsBranded = CosmosIconGooglePodcastsBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePodcastsBranded, defineCustomElement };
